import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';

import grey from '@material-ui/core/colors/grey';
import indigo from '@material-ui/core/colors/indigo';

import {
  startRemoveWebsitePortfolio,
} from 'store/actions/website';
import { ConfirmDialog } from 'components/admin/Dialogs';

const styles = theme => ({
  root:{
    margin: theme.spacing.unit*2,
    width: '350px',
    display: 'flex',
    flexDirection: 'column',
  },
  avatar: {
    color: '#fff',
    backgroundColor: indigo[300],
  },
  content: {
    backgroundColor: indigo[50],
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
  },
  header: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
    '&:hover': {
      cursor: 'pointer',
    },
  },
});

class PortfolioCard extends Component {
  constructor(props) {
    super(props);
    this.state = { showDelete: false };
  }

  handleCancel = () => {
    this.setState({ showDelete: false });
  }

  handleDelete = () => {
    const { portfolioItem, startRemoveWebsitePortfolio } = this.props;
    startRemoveWebsitePortfolio(portfolioItem.id);
    this.setState({ showDelete: false });
  }

  render() {
    const {
      classes,
      file,
      portfolioItem,
      handleDialog,
      startRemoveWebsitePortfolio
    } = this.props;
    const { showDelete } = this.state;

    return(
      <div>
        <ConfirmDialog
          open={showDelete}
          title="Delete Portfolio Item"
          contentText="This action will delete the portfolio item. Proceed?"
          handleCancel={this.handleCancel}
          handleOk={this.handleDelete}
        />
        <Card
          className={classes.root}
        >
          <CardHeader
            className={classes.header}
            action={
              <FormControlLabel
                className={classes.show}
                control={
                  <Switch
                    disabled
                    color="primary"
                    checked={portfolioItem.show}
                  />
                }
                label={portfolioItem.show ? "show" : "hide"}
              />
            }
            avatar={
              <Avatar className={classes.avatar}>
                P
              </Avatar>
            }
            title={portfolioItem.title}
            onClick={() => handleDialog(portfolioItem)}
          />
          <CardMedia
            className={classes.media}
            image={portfolioItem.downloadURL}
            onClick={() => handleDialog(portfolioItem)}
          />
          <CardActions>
            <Button onClick={() => this.setState({ showDelete: true })}>
              Delete
            </Button>
          </CardActions>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { portfolioItem } = props;

  return ({
    file: state.filesState.find((file) => file.id === portfolioItem.fileId),
  });
};

const mapDispatchToProps = {
  startRemoveWebsitePortfolio,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(PortfolioCard);



// WEBPACK FOOTER //
// ./src/components/admin/Website/Portfolio/PortfolioCard.jsx